import { jsx as _jsx } from "react/jsx-runtime";
import { MessageBox } from 'shared/components/dialogs/message-box';
import { Typography } from '@mui/material';
import { memo, useEffect } from 'react';
import { idleDidEnter, idleDidLeave } from 'console/idle/reducer';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { useIdle } from '@uidotdev/usehooks';
import { useCometContext } from 'console/shared/api/comet/comet-context';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { getIdleModeEnabled } from 'console/redux/settings-actions';
const timeout = 10 * 60 * 1e3;
export const IdleDialog = memo(function IdleDialog() {
    const idle_mode_enabled = useAppSelector(getIdleModeEnabled);
    const idle = useIdle(timeout);
    const [opened, close, open] = useBooleanState(idle);
    const comet = useCometContext();
    const _idleDidEnter = useAction(idleDidEnter);
    const _idleDidLeave = useAction(idleDidLeave);
    useEffect(() => {
        if (idle_mode_enabled) {
            if (idle) {
                _idleDidEnter();
                comet.setActive(false);
                if (idle != opened) {
                    open();
                }
            }
            else {
                _idleDidLeave();
                comet.setActive(true);
                close();
            }
        }
    }, [idle]);
    return (_jsx(MessageBox, { open: opened, onClose: close, title: "\u0421\u043F\u044F\u0449\u0438\u0439 \u0440\u0435\u0436\u0438\u043C", closeButtonTitle: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0440\u0430\u0431\u043E\u0442\u0435", children: _jsx(Typography, { variant: "subtitle1", color: "textSecondary", children: "\u0414\u043B\u044F \u044D\u043A\u043E\u043D\u043E\u043C\u0438\u0438 \u0442\u0440\u0430\u0444\u0438\u043A\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u0431\u044B\u043B\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E" }) }));
});
